import moment from "moment";

// Form 组件中使用 DatePicker 组件填写的时间为 Moment 类型，无法直接存入数据库
export const MomentToDateTime = (data) => {
    if (Object.keys(data).length > 0) {
        // 将提交的 data 中属于 Moment 类型数据转成 DateTime 类型，保存到数据库中
        return Object.keys(data).map(key => {
            if (moment.isMoment(data[key])) {
                // 将精确到日的时间的小时设为凌晨 8 点，而不是 0 点，错过了 00:00:00 ~ 01:00:00 这段时间，可以避免夏令时的问题
                return {[key]: moment(data[key]).set({ hour: 8, minute: 0, second: 0 }).format('YYYY-MM-DD HH:mm:ss')}
            } else {
                return {[key]: data[key]}
            }
        }).reduce((prev, next) => ({...prev, ...next}));
    } else {
        return {};
    }
}


// 数据库中 DateTime 类型的时间读出后是 String 类型
export const DateTimeToMoment = (currentItem) => {
    if (Object.keys(currentItem).length > 0) {
        // 将 currentItem 中属于 DateTime 类型的元素转成 Moment 类型，实现在页面的 DatePicker 组件中显示
        return Object.keys(currentItem).map(key => {
            const regEx = /^\d{4}-\d{2}-\d{2}$/;
            if (typeof currentItem[key] === "string" && regEx.test(currentItem[key])) {
                return {[key]: moment(currentItem[key], 'YYYY-MM-DD')}
            } else {
                return {[key]: currentItem[key]}
            }
        }).reduce((prev, next) => ({...prev, ...next}));
    } else {
        return {};
    }
}

// 将民非研究人员信息字段改成当前表格中的字段
export const MfToSociety = (currentItem) => {
    if (Object.keys(currentItem).length > 0) {
        // 将 peopleName 等字段改成 memberName
        return Object.keys(currentItem).map(key => {
            return {[key.replace("people", "member")
                    .replace("Education", "Educational")
                    .replace("mbsk", "organization")] : currentItem[key]}
        }).reduce((prev, next) => ({...prev, ...next}));
    } else {
        return {};
    }
}
